<template>
  <v-dialog :value="shown" :max-width="350" persistent @keydown.esc="choose(false)">
    <v-card tile>
      <v-card-text><slot v-bind:data="data"/></v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="grey" @click="choose(false)" :data-test="`confirmDialogNo${$attrs['data-test']}`">No</v-btn>
        <v-btn color="primary" @click="choose(true)" :data-test="`confirmDialogYes${$attrs['data-test']}`">Yes</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'Confirm',
  data () {
    return {
      shown: false,
      data: null
    }
  },
  methods: {
    choose (result) {
      this.shown = false
      if (result) {
        this.$emit('confirm', this.data)
      } else {
        this.$emit('cancel')
      }
      this.$set(this, 'data', null)
    }
  }
}
</script>
